(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Donut = factory());
}(this, (function () { 'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype;
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

var index = isElement;

var createElementNS = (function (name) {
  return document.createElementNS('http://www.w3.org/2000/svg', name);
});

var setAttributes = (function (dom, attributes) {
  var keys = Object.keys(attributes);

  for (var i = 0, len = keys.length; i < len; i++) {
    var key = keys[i];
    dom.setAttribute(key, attributes[key]);
  }
});

var setStyles = (function (dom, styles) {
  var keys = Object.keys(styles);

  for (var i = 0, len = keys.length; i < len; i++) {
    var key = keys[i];
    dom.style[key] = styles[key];
  }
});

var BOX_SIZE = 100;
var BOX_RADIUS = BOX_SIZE / 2;
var STROKE_WIDTH = 2;
var CIRCLES_GAP = 5;
var DURATION = '1s';
var MOTION = 'cubic-bezier(.99, .01, .22, .94)';

var Donut = function () {
  function Donut(config) {
    classCallCheck(this, Donut);

    this.config = _extends({}, Donut.DEFAULTS, config);
    this.isMultiple = Array.isArray(this.config.circles);
    this.svg = null;
    this.circles = {};
    this.circles.length = 0;
    this.generateDOM();
    this.mountIfSpecifiedEl();
    this.init();
  }

  createClass(Donut, [{
    key: 'generateDOM',
    value: function generateDOM() {
      var _config = this.config,
          size = _config.size,
          commonBackgroundColor = _config.backgroundColor,
          commonProgressColor = _config.progressColor,
          circles = _config.circles;


      var svg = createElementNS('svg');
      size = typeof size === 'number' && size >= 0 ? size + 'px' : '100%';
      setStyles(svg, {
        width: size,
        height: size,
        overflow: 'hidden',
        webkitTransform: 'rotate(-90deg)',
        mozTransform: 'rotate(-90deg)',
        msTransform: 'rotate(-90deg)',
        oTransform: 'rotate(-90deg)',
        transform: 'rotate(-90deg)'
      });
      setAttributes(svg, {
        viewBox: '0 0 ' + BOX_SIZE + ' ' + BOX_SIZE
      });

      if (!this.isMultiple) {
        circles = [{
          backgroundColor: commonBackgroundColor,
          progressColor: commonProgressColor
        }];
      }

      for (var i = 0, len = circles.length; i < len; i++) {
        var _circles$i = circles[i],
            name = _circles$i.name,
            _circles$i$background = _circles$i.backgroundColor,
            backgroundColor = _circles$i$background === undefined ? commonBackgroundColor : _circles$i$background,
            _circles$i$progressCo = _circles$i.progressColor,
            progressColor = _circles$i$progressCo === undefined ? commonProgressColor : _circles$i$progressCo;

        var background = createElementNS('circle');
        var progress = createElementNS('circle');
        var radius = BOX_RADIUS - (i + 1) * CIRCLES_GAP - i * STROKE_WIDTH;
        var circumference = Math.PI * radius * 2;

        setAttributes(background, {
          cx: BOX_RADIUS,
          cy: BOX_RADIUS,
          r: radius,
          fill: 'none',
          'stroke-width': STROKE_WIDTH,
          stroke: backgroundColor
        });

        setAttributes(progress, {
          cx: BOX_RADIUS,
          cy: BOX_RADIUS,
          r: radius,
          fill: 'none',
          'stroke-width': STROKE_WIDTH,
          stroke: progressColor,
          'stroke-linejoin': 'round',
          'stroke-linecap': 'round'
        });

        setStyles(progress, {
          strokeDasharray: circumference,
          strokeDashoffset: circumference,
          webkitTransition: 'stroke-dashoffset ' + DURATION + ' ' + MOTION + ' 0s',
          mozTransition: 'stroke-dashoffset ' + DURATION + ' ' + MOTION + ' 0s',
          msTransform: 'stroke-dashoffset ' + DURATION + ' ' + MOTION + ' 0s',
          oTransform: 'stroke-dashoffset ' + DURATION + ' ' + MOTION + ' 0s',
          transition: 'stroke-dashoffset ' + DURATION + ' ' + MOTION + ' 0s'
        });

        var circle = [progress, circumference];
        if (name) this.circles[name] = circle;
        this.circles[i] = circle;
        this.circles.length++;

        svg.appendChild(background);
        svg.appendChild(progress);
      }

      this.svg = svg;
    }
  }, {
    key: 'mountIfSpecifiedEl',
    value: function mountIfSpecifiedEl() {
      var el = this.config.el;

      var isString = typeof el === 'string';

      if (!el || !isString && !index(el)) return;

      if (isString) {
        el = document.querySelector(el);
        if (!el && !index(el)) return;
      }

      el.appendChild(this.svg);
      this.svg = null;
    }
  }, {
    key: 'getDOM',
    value: function getDOM() {
      if (!this.svg) {
        console.error('You can\'t call the getNode method after the Donut instance was mounted.');
        return;
      }
      return this.svg;
    }
  }, {
    key: 'init',
    value: function init() {
      var commonValue = this.config.value;

      if (!this.isMultiple) {
        this.setValue(commonValue);
      } else {
        for (var i = 0, len = this.circles.length; i < len; i++) {
          var _config$circles$i$val = this.config.circles[i].value,
              value = _config$circles$i$val === undefined ? commonValue : _config$circles$i$val;

          this.setValue(i, value);
        }
      }
    }
  }, {
    key: 'setValue',
    value: function setValue(name, value) {
      if (name == null) return;
      if (name != null && this.isMultiple && value == null) return;
      if (!this.isMultiple && typeof name !== 'number') return;

      var circle = null;

      if (typeof name === 'number' && !this.isMultiple) {
        value = name;
        circle = this.circles[0];
      } else {
        circle = this.circles[name];
      }

      if (!circle) return;

      var progress = circle[0];
      var circumference = circle[1];
      var offset = circumference - value * circumference;
      setTimeout(function () {
        setStyles(progress, {
          strokeDashoffset: offset
        });
      });
    }
  }]);
  return Donut;
}();

Donut.DEFAULTS = {
  backgroundColor: 'rgba(0, 0, 0, .25)',
  progressColor: '#2196F3',
  value: 0
};

return Donut;

})));

//# sourceMappingURL=donut.js.map
